import {
  AccountAnnualIncomeDto,
  AccountLiquidNetWorthDto,
  AccountTaxBracketDto,
  AccountTotalNetWorthDto,
} from 'src/dtos';
import {
  AccountAnnualIncomeLabel,
  AccountLiquidNetWorthLabel,
  AccountTaxBracketLabel,
  AccountTotalNetWorthLabel,
} from 'src/models';

export const ANNUAL_INCOME_OPTION_LIST = [
  {
    value: AccountAnnualIncomeDto.LessThan25K,
    label: AccountAnnualIncomeLabel.LessThan25K,
  },
  {
    value: AccountAnnualIncomeDto.Between25KAnd50K,
    label: AccountAnnualIncomeLabel.Between25KAnd50K,
  },
  {
    value: AccountAnnualIncomeDto.Between50KAnd100K,
    label: AccountAnnualIncomeLabel.Between50KAnd100K,
  },
  {
    value: AccountAnnualIncomeDto.Between100KAnd200K,
    label: AccountAnnualIncomeLabel.Between100KAnd200K,
  },
  {
    value: AccountAnnualIncomeDto.Between200KAnd300K,
    label: AccountAnnualIncomeLabel.Between200KAnd300K,
  },
  {
    value: AccountAnnualIncomeDto.Between300KAnd500K,
    label: AccountAnnualIncomeLabel.Between300KAnd500K,
  },
  {
    value: AccountAnnualIncomeDto.Between500KAnd1Point2M,
    label: AccountAnnualIncomeLabel.Between500KAnd1Point2M,
  },
  {
    value: AccountAnnualIncomeDto.MoreThan1Point2M,
    label: AccountAnnualIncomeLabel.MoreThan1Point2M,
  },
];

export const TOTAL_NET_WORTH_OPTION_LIST = [
  {
    value: AccountTotalNetWorthDto.LessThan50K,
    label: AccountTotalNetWorthLabel.LessThan50K,
  },
  {
    value: AccountTotalNetWorthDto.Between50KAnd100K,
    label: AccountTotalNetWorthLabel.Between50KAnd100K,
  },
  {
    value: AccountTotalNetWorthDto.Between100KAnd200K,
    label: AccountTotalNetWorthLabel.Between100KAnd200K,
  },
  {
    value: AccountTotalNetWorthDto.Between200KAnd500K,
    label: AccountTotalNetWorthLabel.Between200KAnd500K,
  },
  {
    value: AccountTotalNetWorthDto.Between500KAnd1M,
    label: AccountTotalNetWorthLabel.Between500KAnd1M,
  },
  {
    value: AccountTotalNetWorthDto.Between1MAnd5M,
    label: AccountTotalNetWorthLabel.Between1MAnd5M,
  },
  {
    value: AccountTotalNetWorthDto.MoreThan5M,
    label: AccountTotalNetWorthLabel.MoreThan5M,
  },
];

export const LIQUID_NET_WORTH_OPTION_LIST = [
  {
    value: AccountLiquidNetWorthDto.LessThan50K,
    label: AccountLiquidNetWorthLabel.LessThan50K,
  },
  {
    value: AccountLiquidNetWorthDto.Between50KAnd100K,
    label: AccountLiquidNetWorthLabel.Between50KAnd100K,
  },
  {
    value: AccountLiquidNetWorthDto.Between100KAnd200K,
    label: AccountLiquidNetWorthLabel.Between100KAnd200K,
  },
  {
    value: AccountLiquidNetWorthDto.Between200KAnd500K,
    label: AccountLiquidNetWorthLabel.Between200KAnd500K,
  },
  {
    value: AccountLiquidNetWorthDto.Between500KAnd1M,
    label: AccountLiquidNetWorthLabel.Between500KAnd1M,
  },
  {
    value: AccountLiquidNetWorthDto.Between1MAnd5M,
    label: AccountLiquidNetWorthLabel.Between1MAnd5M,
  },
  {
    value: AccountLiquidNetWorthDto.MoreThan5M,
    label: AccountLiquidNetWorthLabel.MoreThan5M,
  },
];

export const TAX_BRACKET_OPTION_LIST = [
  {
    value: AccountTaxBracketDto.Bottom,
    label: AccountTaxBracketLabel.Bottom,
  },
  {
    value: AccountTaxBracketDto.Middle,
    label: AccountTaxBracketLabel.Middle,
  },
  {
    value: AccountTaxBracketDto.Top,
    label: AccountTaxBracketLabel.Top,
  },
];
